<template>
  <div class="screen">
    <div class="page-wrap">
      <div class="screen-name">
        <label class="name">正安西南水泥有限公司</label>
        <label class="time" id="time">{{ currentTime }}</label>
      </div>
      <div class="screen-content">
        <leftPart></leftPart>
        <centerPart></centerPart>
        <rightPart></rightPart>
      </div>
    </div>
    <img class="dongImg" src="../../assets/picture/center/WechatIMG251.gif" alt="">
  </div>
</template>

<script>
import leftPart from "@/components/home/leftPart.vue";
import centerPart from "@/components/home/centerPart.vue";
import rightPart from "@/components/home/rightPart.vue";
export default {
  data() {
    return {
      timer: "",
      currentTime: new Date(),
    };
  },
  components: {
    leftPart,
    centerPart,
    rightPart,
  },
  created() {
    var _this = this;
    _this.timer = setInterval(function () {
      let m = new Date().getMonth() + 1;
      let d = new Date().getDate();
      let h = new Date().getHours();
      let min = new Date().getMinutes();
      let s = new Date().getSeconds();
      _this.currentTime =
        new Date().getFullYear() +
        "-" +
        _this.appendZero(m) +
        "-" +
        _this.appendZero(d) +
        " " +
        _this.appendZero(h) +
        ":" +
        _this.appendZero(min) +
        ": " +
        _this.appendZero(s);
    }, 1000);
  },
  mounted() {},
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    appendZero(obj) {
      if (obj < 10) {
        return "0" + obj;
      } else {
        return obj;
      }
    },
    nowTime() {
      //获取年月日
      var time = new Date();
      var year = time.getFullYear();
      var month = time.getMonth();
      var day = time.getDate();

      //获取时分秒
      var h = time.getHours();
      var m = time.getMinutes();
      var s = time.getSeconds();

      //检查是否小于10
      h = this.check(h);
      m = this.check(m);
      s = this.check(s);
      document.getElementById("time").innerHTML =
        "当前时间：" +
        year +
        "年" +
        month +
        "月" +
        day +
        "日  " +
        h +
        ":" +
        m +
        ":" +
        s;
    },
    //时间数字小于10，则在之前加个“0”补位。
    check(i) {
      //方法一，用三元运算符
      var num;
      i < 10 ? (num = "0" + i) : (num = i);
      return num;

      //方法二，if语句判断
      //if(i<10){
      //    i="0"+i;
      //}
      //return i;
    },
  },
};
</script>

<style scoped>
@font-face {
  font-family: "pangmenzhangdao";
  src: url("../../assets/font/庞门正道标题体2.0增强版.woff2") format("woff2"),
    url("../../assets/font/庞门正道标题体2.0增强版.woff") format("woff"),
    url("../../assets/font/庞门正道标题体2.0增强版.ttf") format("truetype"),
    url("../../assets/font/庞门正道标题体2.0增强版.eot")
      format("embedded-opentype"),
    url("../../assets/font/庞门正道标题体2.0增强版.svg") format("svg");
}
.screen {
  background: url("../../assets/picture/bg_icon.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 100%;
}
.dongImg{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1;
}
.screen-name {
  position: relative;
  text-align: center;
}
.name {
  font-family: "pangmenzhangdao";
  text-align: center;
  font-size: 2rem;
  height: 80px;
  line-height: 80px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.time {
  position: absolute;
  top: 0.5rem;
  right: 1.5rem;
  font-size: 1rem;
  color: #23cefd;
}
.screen-content {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  flex: 1;
  margin-top: -2rem;
  z-index: 99999;
}

.page-wrap {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  flex: 1;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/home/index.vue